module.exports = __webpack_public_path__ + "media/images/icons/headphones-bf040b5625810a8b915f8b9202e9d1c7.svg";